<template lang="pug">
tweet-embed
  template(slot='tweet')
    blockquote.twitter-tweet(data-theme='dark')
      p(lang='en', dir='ltr')
        | Keep scanning for the second clue, leading to our Sydney location.
        a(href='https://twitter.com/hashtag/SWJediSurvivorSaberHunt?src=hash&ref_src=twsrc%5Etfw') #SWJediSurvivorSaberHunt
        br
        br
        | &#x1F449;
        a(href='https://t.co/NBwHswSHUM') https://t.co/NBwHswSHUM
        a(href='https://t.co/ywZMNvH2t7') pic.twitter.com/ywZMNvH2t7
      | &mdash; EA Star Wars (@EAStarWars)
      a(href='https://twitter.com/EAStarWars/status/1625631168690266112?ref_src=twsrc%5Etfw') February 14, 2023
</template>
<script>
// @see https://help.twitter.com/en/using-twitter/how-to-embed-a-tweet
// @see https://html-to-pug.com/
import TweetEmbed from '../../../../../components/TweetEmbed.vue'

export default {
  components: {
    TweetEmbed
  }
}
</script>
